import MUISwitch from "./MUISwitch"
import Stack from '@mui/material/Stack';
import { useState, useEffect } from "react";
import { Card, Box, Typography } from "@mui/material";
import Gauge from "./Gauge";

export default function SwitchGauge(props){
    //console.log("IN SwitchGauge I AM IN");

    const [energycostbudget, setEnergyCostBudget] = useState(true); //false->shows INR , True->shows kWh
    const [stateVarB, setStateVarB] = useState(true);
    const[exceed, setExceed] = useState(false);
    const[percentageConsumed, setPercentageConsumed] = useState(0);
    const[targetvalue, setTargetValue] = useState(0);
    const[totalvalue, setTotalValue] = useState(0);
    const gaugecallback = (valueobtained) =>{
        setPercentageConsumed(valueobtained)
    }
    function handleChange2(event){
      setStateVarB(!stateVarB.checkedB);
    };

    useEffect(()=>{

    },[percentageConsumed])
    return(  
        <>
            <div style={{position:'relative'}}>
                {   /*console.log("energycostbudget.checked",energycostbudget*/     }
                <Stack direction="row" spacing={1} alignItems="center" sx={{marginLeft:"17px",marginTop:"20px"}}>
                    <MUISwitch checkedA={energycostbudget} energycostbudget={energycostbudget} setEnergyCostBudget={setEnergyCostBudget} widgetprop={props.widgetprop} /> 
                </Stack>

                <Typography sx={{position:'absolute',zIndex:0, top:"3px", left:"250px" ,color:'var(--widget-text-color)',fontSize:"16px", fontWeight:400, fontFamily:'Roboto'}}>Target:  {targetvalue}</Typography> 
                <Typography sx={{position:'absolute',zIndex:0, top:"23px", left:"250px" ,color:'var(--widget-text-color)',fontSize:"16px", fontWeight:400, fontFamily:'Roboto'}}>Max Limit:  {totalvalue}</Typography> 
                <Gauge widgetprop={props.widgetprop} energycostbudget={energycostbudget} exceed={exceed} setExceed={setExceed} gaugecallback={gaugecallback} setPercentageConsumed={setPercentageConsumed} setTargetValue={setTargetValue} setTotalValue={setTotalValue}/>
                
                {/* <Typography sx={{position:'absolute',zIndex:0, top:"195px", left:"30px" ,color:'var(--widget-text-color)',fontSize:"16px", fontWeight:400, fontFamily:'Roboto'}}>{percentageConsumed}% of Max Limit is consumed</Typography> */}
                {(exceed==false) && <Typography sx={{position:'absolute', zIndex:0, top:"195px", left:"300px" ,color:"#00943D",fontSize:"16px", fontWeight:400, fontFamily:'Roboto'}}>We are on Target</Typography>}
                {(exceed==true) && <Typography sx={{position:'absolute', zIndex:0, top:"195px", left:"300px" ,color:"#DC272D",fontSize:"16px", fontWeight:400, fontFamily:'Roboto'}}>Target Exceeded</Typography>}
            
            </div>
        </>
    )
}